import request from './request.js'
//公用调取接口
export function getCommonAjax(url, data, responseType) {
    return request({
        url: url,
        method: 'get',
        params: data,
        responseType
    })
}
//公用调取接口
export function postCommonAjax(url, data) {
    return request({
        url: url,
        method: 'post',
        data
    })
}

export function postCommonAjaxCif(url, data, headers) {
    return request({
        url: url,
        method: 'post',
        data,
        headers
    })
}

//公用调取接口
export function deleteCommonAjax(url, data) {
    return request({
        url: url,
        method: 'delete',
        params: data
    })
}
//公用调取接口
export function putCommonAjax(url, data) {
    return request({
        url: url,
        method: 'put',
        data
    })
}
